var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27104 15.6562C10.5345 12.9278 14.7111 11.1291 16.8009 10.2601C22.7677 7.77874 24.0075 7.34771 24.8157 7.33348C24.9934 7.33035 25.3908 7.37439 25.6482 7.58323C25.8656 7.75957 25.9254 7.99778 25.954 8.16498C25.9826 8.33217 26.0183 8.71303 25.9899 9.01063C25.6666 12.4074 24.2675 20.6503 23.5557 24.4547C23.2545 26.0645 22.6615 26.6042 22.0874 26.6571C20.8397 26.7719 19.8922 25.8327 18.6838 25.0406C16.7928 23.8013 15.7245 23.0298 13.8889 21.8204C11.7676 20.4228 13.1428 19.6546 14.3517 18.3992C14.6681 18.0707 20.1655 13.0713 20.2719 12.6178C20.2852 12.5611 20.2975 12.3496 20.1719 12.238C20.0463 12.1264 19.8609 12.1645 19.7271 12.1949C19.5374 12.2379 16.5165 14.2343 10.6643 18.1839C9.80685 18.7726 9.03018 19.0594 8.3343 19.0444C7.56716 19.0278 6.09148 18.6107 4.99446 18.2542C3.64893 17.8169 2.57952 17.5857 2.67264 16.843C2.72115 16.4562 3.25394 16.0606 4.27104 15.6562Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.e91918b3.svg";
export { ForwardRef as ReactComponent };